import equal from 'fast-deep-equal';
import { useEffect, useState, useMemo } from 'react';

const VERBOSE = false;

export const useInitSelectedVariant = (product = null) => {
  const [selectedVariant, setSelectedVariant] = useState(null);
  const [selectedOptions, setSelectedOptions] = useState(null);
  // const [selectedMedia, setSelectedMedia] = useState(null);

  const selectedMedia = useMemo(() => {
    if (!product?.media || !selectedOptions) return [];
    const { color } = selectedOptions;
    return color
      ? product.media.filter(({ product: p }) => {
          return p?.tags?.find((tag) =>
            tag.match(new RegExp(`color::${color}`, 'gi'))
          )?.length;
        })
      : product.media;
  }, [selectedOptions, product?.media]);

  // set initial variant
  useEffect(() => {
    if (!product) return;

    const isApparel = product?.productType === 'Apparel';
    const firstAvailableVariant = isApparel
      ? product?.variants?.find(({ availableForSale }) => availableForSale)
      : null;

    const variant = firstAvailableVariant || product?.variants?.[0];
    setSelectedVariant(variant);

    if (variant) {
      setSelectedOptions(variant?.selectedOptionsMap);
    } else {
      // Should never be get here..
      setSelectedOptions(null);
    }
    return () => {
      // on unmount
      setSelectedOptions(null);
    };
  }, [product?.handle]);

  useEffect(() => {
    const getVariantFromOptions = (options, variants) => {
      return variants?.find(({ selectedOptionsMap }) => {
        return equal(selectedOptions, selectedOptionsMap);
      });
    };
    const _selectedVariant = getVariantFromOptions(
      selectedOptions,
      product?.variants || []
    );
    if (_selectedVariant) {
      setSelectedVariant(_selectedVariant);
    }
  }, [product?.handle, selectedOptions]);

  return {
    selectedVariant,
    selectedOptions,
    setSelectedOptions,
    selectedMedia,
  };
};
